<template>
    <div class="detail-page">
        <app-header :title="listData[index].name" />
        <oasis-carousel class="carousel" :index="parseInt(index || 0)" :list-data="listData"></oasis-carousel>
    </div>
</template>
<style scoped>
    .detail-page {
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .detail-page .carousel {
        height: calc(100% - 48px)
    }
</style>
<script>
import AppHeader from './AppHeader'
import OasisCarousel from './carousel/src/main'
import { listData } from '../listData'
export default {
    components: { OasisCarousel, AppHeader },
    name: 'detail-page',
    props: { index: [String, Number] },
    data () {
        return {
            listData
        }
    },
    methods: {
        goTop () {
            this.$router.push({
                name: 'top'
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DetailPage.vue